import classnames from 'classnames';
import moment from 'moment';
import React from 'react';
import type { Moment } from 'moment';
import { MomentDatePicker } from './momentDatePicker';

export type DatePickerInputProps = {
  className?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  isError?: boolean;
  errorMessage?: string;
  isWarning?: boolean;
  warningMessage?: string;
  value?: Moment;
  belowLimit?: number;
  aboveLimit?: number;
  disabled?: boolean;
  onChange: (value: Moment | null, dateString: string | string[]) => void;
  suffixIcon?: React.ReactNode;
  allowClear?: boolean;
  showToday?: boolean;
};

const DatePickerInput = ({
  className,
  label = '',
  name,
  placeholder = '',
  isError = false,
  errorMessage = '',
  isWarning = false,
  warningMessage,
  value,
  belowLimit,
  aboveLimit,
  disabled = false,
  onChange,
  suffixIcon,
  allowClear = false,
  showToday = false,
}: DatePickerInputProps) => (
  <div className={classnames('custom-date-picker-input', className)}>
    {!!label && <div className="custom-date-picker-input__label">{label}</div>}
    <MomentDatePicker
      className={classnames('custom-date-picker-input__calendar-picker', isError ? '--error' : '')}
      placeholder={placeholder}
      disabledDate={(currentDate: Moment) => {
        const currentDateStartOfDay = moment(currentDate.format('MM/DD/YYYY')).startOf('day');
        const currentDateEndOfDay = moment(currentDate.format('MM/DD/YYYY')).endOf('day');
        return (
          currentDateStartOfDay.valueOf() < (belowLimit as number) ||
          currentDateEndOfDay.valueOf() > (aboveLimit as number)
        );
      }}
      name={name}
      value={value}
      onChange={onChange}
      format="MM/DD/YYYY"
      disabled={disabled}
      suffixIcon={suffixIcon}
      allowClear={allowClear}
      showToday={showToday}
    />
    {isError && !!errorMessage && (
      <div className="custom-date-picker-input__error-message">{errorMessage}</div>
    )}
    {isWarning && (
      <div className="custom-date-picker-input__warning-container">
        <div className="custom-date-picker-input__warning-message">{warningMessage}</div>
      </div>
    )}
  </div>
);

export default DatePickerInput;
